"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadService = void 0;
const index_1 = require("./index");
class DownloadService {
    constructor() {
        this.__priority = 100;
        this.lastDownloadFilename = null;
    }
    download(url, filename) {
        return setTimeout(() => {
            const link = index_1.Services.Window.document.createElement('a');
            link.download = filename == null ? '' : filename;
            link.href = url;
            index_1.Services.Window.document.body.appendChild(link);
            link.click();
            link.remove();
            this.lastDownloadFilename = filename !== null && filename !== void 0 ? filename : null;
        }, 250);
    }
}
exports.DownloadService = DownloadService;
//# sourceMappingURL=download.service.js.map